import { render, staticRenderFns } from "./borrowList.vue?vue&type=template&id=2b516850&"
import script from "./borrowList.vue?vue&type=script&lang=js&"
export * from "./borrowList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports